import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import { useEffect } from "react";

const utils = createTrackingUtils({
  name: "flights_web_sr_gen_ai_studio_migration",
  stages: {
    direct: 2,
    meta: 3
  },
  goals: {
    success: 1,
    error: 2,
    ctaClick: 3
  },
  defaultStage: 1
});

const useTrackStages = () => {
  const { stages } = utils;
  const { isDirect, isMeta } = useProfiler();

  useEffect(() => {
    isDirect() && stages.direct();
    isMeta() && stages.meta();
  }, [stages, isDirect, isMeta]);
};

export default { ...utils, useTrackStages };
